import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useState } from 'react';
var ToolbarDropdownMenuContext = /*#__PURE__*/createContext(undefined);
export var useToolbarDropdownMenu = function useToolbarDropdownMenu() {
  var context = useContext(ToolbarDropdownMenuContext);
  if (!context) {
    throw new Error('useToolbarDropdownMenu must be used within ToolbarDropdownMenuProvider');
  }
  return context;
};
export var ToolbarDropdownMenuProvider = function ToolbarDropdownMenuProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var openMenu = function openMenu() {
    return setIsOpen(true);
  };
  var closeMenu = function closeMenu() {
    setIsOpen(false);
  };
  var contextValue = {
    openMenu: openMenu,
    closeMenu: closeMenu,
    isOpen: isOpen
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownMenuContext.Provider, {
    value: contextValue
  }, children);
};